module.exports = __webpack_public_path__ + "static/media/light-theme-idling.d4112cdf.svg";